// extracted by mini-css-extract-plugin
module.exports = {"emailInfo":"VerifyEmailSection-emailInfo_fc19672b","emailAccountInfoItem":"VerifyEmailSection-emailAccountInfoItem_7202b30e","email":"VerifyEmailSection-email_c39ea208"};